module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [
    [_c('swiper', {
      ref: "mySwiper",
      attrs: {
        "options": _vm.swiperOption
      }
    }, [_c('swiper-slide', [_c('img', {
      attrs: {
        "src": require("../../static/images/banner/bg.jpg")
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "title localServiceBanner"
    }, [_c('div', {
      staticClass: "bigTitle"
    }, [_vm._v("车联网位置服务平台")]), _vm._v(" "), _c('div', {
      staticClass: "secondTitle"
    }, [_vm._v("全新上线")]), _vm._v(" "), _c('div', {
      staticClass: "thridTitle"
    }, [_c('span', [_c('img', {
      attrs: {
        "src": require("../../static/images/banner/icon.png")
      }
    }), _vm._v("实时位置监控")]), _vm._v(" "), _c('span', [_c('img', {
      attrs: {
        "src": require("../../static/images/banner/icon.png")
      }
    }), _vm._v("真实轨迹还原")]), _vm._v(" "), _c('span', [_c('img', {
      attrs: {
        "src": require("../../static/images/banner/icon.png")
      }
    }), _vm._v("车辆BI分析")])]), _vm._v(" "), _c('p', {
      staticClass: "square_button"
    }, [_c('a', {
      attrs: {
        "href": "http://clw.ishowchina.com:89/mygpsonline",
        "target": "_blank"
      }
    }, [_vm._v("立即体验")])])])]), _vm._v(" "), _c('swiper-slide', [_c('img', {
      attrs: {
        "src": require("../../static/images/banner/banner1bg.jpg")
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "title"
    }, [_c('div', {
      staticClass: "bigTitle"
    }, [_vm._v("我秀中国 · 车伴侣")]), _vm._v(" "), _c('div', {
      staticClass: "secondTitle"
    }, [_vm._v("我们专注为您的企业提供轨迹大数据服务及行车位置监控服务")]), _vm._v(" "), _c('div', {
      staticClass: "underTitle green"
    }, [_vm._v("车辆端活跃量")]), _vm._v(" "), _c('flip-num')], 1)]), _vm._v(" "), _c('div', {
      staticClass: "swiper-pagination",
      attrs: {
        "slot": "pagination"
      },
      slot: "pagination"
    }, [_c('span', {
      staticClass: "swiper_icon"
    }), _vm._v(" "), _c('span', {
      staticClass: "swiper_icon"
    })]), _vm._v(" "), _c('div', {
      staticClass: "swiper-button-prev",
      attrs: {
        "slot": "button-prev"
      },
      slot: "button-prev"
    }), _vm._v(" "), _c('div', {
      staticClass: "swiper-button-next",
      attrs: {
        "slot": "button-next"
      },
      slot: "button-next"
    })], 1)]
  ], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-94de0448","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/banner.vue
// module id = 141
// module chunks = 1